'use client';
import * as __WEBPACK_EXTERNAL_MODULE_react__ from "react";
import * as __WEBPACK_EXTERNAL_MODULE_swr__ from "swr";
import * as __WEBPACK_EXTERNAL_MODULE__nestle_npus_nbm_purina_auth_11a881f8__ from "@nestle-npus-nbm/purina-auth";
import * as __WEBPACK_EXTERNAL_MODULE__useGetAuth0User_mjs_8e625b7b__ from "./useGetAuth0User.mjs";
import * as __WEBPACK_EXTERNAL_MODULE__api_index_mjs_d46e3cfc__ from "../../api/index.mjs";
import * as __WEBPACK_EXTERNAL_MODULE__common_functions_mjs_d8c9400b__ from "../../common/functions.mjs";
const useGetUser = (config, skipUserFetchIfTandCAccepted)=>{
    const sstService = __WEBPACK_EXTERNAL_MODULE_react__["default"].useMemo(()=>new __WEBPACK_EXTERNAL_MODULE__api_index_mjs_d46e3cfc__.SstServices({
            baseUrl: (0, __WEBPACK_EXTERNAL_MODULE__common_functions_mjs_d8c9400b__.getApiUrl)(config.auth0.domain),
            baseApiParams: {
                secure: true
            },
            securityWorker: (securityData)=>{
                if (securityData) return {
                    headers: {
                        Authorization: securityData.token
                    }
                };
            }
        }), [
        config.auth0.domain
    ]);
    const { ansiraUuid, attributes, accessToken, isLoading: isAuth0UserLoading } = (0, __WEBPACK_EXTERNAL_MODULE__useGetAuth0User_mjs_8e625b7b__.useGetAuth0User)(config);
    const fetcher = ()=>{
        if (accessToken) sstService.setSecurityData({
            token: accessToken
        });
        return sstService.getUserByUserIdSstServicesV1UsersUserIdGet(ansiraUuid || '');
    };
    const termsAndConditions = attributes?.[__WEBPACK_EXTERNAL_MODULE__nestle_npus_nbm_purina_auth_11a881f8__.idTokenPayloadKeys.termsAndConditions];
    let shouldFetch = true;
    if (skipUserFetchIfTandCAccepted && true === termsAndConditions) shouldFetch = false;
    const { data: user, error, isLoading, mutate } = (0, __WEBPACK_EXTERNAL_MODULE_swr__["default"])(shouldFetch && ansiraUuid ? 'GetUser' : null, fetcher, {
        revalidateOnFocus: false,
        errorRetryCount: 3,
        dedupingInterval: 5000
    });
    return {
        user: user?.data?.data,
        error,
        isLoading: isLoading || isAuth0UserLoading,
        mutate
    };
};
export { useGetUser };
